import { BookingPricingType } from '@/types';
import type { GuidePricing } from '@/types';

export function calculateBookingAmount(
  pricing: Pick<GuidePricing, 'hourlyPrice' | 'fullDayPrice'>,
  pricingType: BookingPricingType,
  duration: number,
  travelerCount: number
): number {
  let unitPrice = 0;
  switch (pricingType) {
    case BookingPricingType.HOURLY:
      unitPrice = pricing.hourlyPrice ?? 0;
      break;
    case BookingPricingType.FULL_DAY:
      unitPrice = pricing.fullDayPrice ?? 0;
      break;
    default:
      unitPrice = 0;
      break;
  }
  return Math.round(unitPrice * duration * travelerCount * 100) / 100;
}

export const PRICING_TYPE_LABELS: Record<BookingPricingType, string> = {
  [BookingPricingType.HOURLY]: 'Few hours',
  [BookingPricingType.FULL_DAY]: 'Full day',
};

export function getAvailablePricingTypes(pricing?: GuidePricing | null): BookingPricingType[] {
  if (!pricing) return [];
  const types: BookingPricingType[] = [];
  if (pricing.hourlyPrice != null && pricing.hourlyPrice > 0) {
    types.push(BookingPricingType.HOURLY);
  }
  if (pricing.fullDayPrice != null && pricing.fullDayPrice > 0) {
    types.push(BookingPricingType.FULL_DAY);
  }
  return types;
}
